import LanguagePopUp from "./LanguagePopUp/LanguagePopUp";
import PlacePopUp from "./PlacePopUp/PlacePopUp";
import DistancePopUp from "./DistancePopUp/DistancePopUp";
import HourlyRatePopUp from "./HourlyRatePopUp/HourlyRatePopUp";
import GenderPopUp from "./GenderPopUp/GenderPopUp";
import QualificationPopUp from "./QualificationPopUp/QualificationPopUp";

export const popUps = [
	{
		key: "Sprache",
		component: LanguagePopUp
	},
	{
		key: "Einsatzort",
		component: PlacePopUp
	},
	{
		key: "Entfernung",
		component: DistancePopUp
	},
	{
		key: "Stundensatz",
		component: HourlyRatePopUp
	},
	{
		key: "Geshlecht",
		component: GenderPopUp
	},
	{
		key: "Qualifikation",
		component: QualificationPopUp
	}
];
